import { render, staticRenderFns } from "./DataListing.vue?vue&type=template&id=7f711837&scoped=true&"
import script from "./DataListing.vue?vue&type=script&lang=js&"
export * from "./DataListing.vue?vue&type=script&lang=js&"
import style0 from "./DataListing.vue?vue&type=style&index=0&id=7f711837&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f711837",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
